<script lang="ts">
    import {onMount} from "svelte";
    import {OfferItem} from "../entities/OfferItem";
    import {assets} from "../three/assets/materials";
    import {createRenderer} from "../three/Renderer";
    import * as THREE from "three";
    import {Scene} from "../three/Scene";
    import RotationButton from "./RotationButton.svelte";
    import {getPreviewData} from "../repo";

    export let location;
    export let navigate;
    export let id;

    let offerItem: OfferItem;
    let freeRotation: boolean = true;
    let renderer: THREE.WebGLRenderer;
    let canvasElem: HTMLCanvasElement;
    let scene: Scene;
    let loaded = false

    onMount(async () => {
        renderer = createRenderer(canvasElem)
        // Waits for all assets to load then builds the scene
        getPreviewData().then(data => {
            offerItem = data
            createScene(offerItem)
        })
    });
    $: {
        if (scene) {
            if (JSON.stringify(scene.formData) !== JSON.stringify(offerItem)) {
                scene.stopRender()
                scene.disposeAll()
                scene.rebuild(offerItem)
            }
            scene.camera.setCameraFreeRotation(freeRotation)
        }
    }
    function createScene(data: OfferItem) {
        assets.ensureLoaded(() => {
            scene = new Scene(canvasElem, renderer);
            scene.build(data)
            loaded = true

            scene.camera.setCameraFreeRotation(freeRotation)
        })
    }

    /**
     * Called on window resize
     * Resizes the scene to fit the new viewport
     */
    function resize() {
        if (!scene) return
        scene.resize();
    }
</script>

<svelte:window on:resize={resize} />
    <canvas class="w-screen h-screen" bind:this={canvasElem} ></canvas>
    {#if scene}
        <RotationButton bind:freeRotation={freeRotation}/>
    {/if}
{#if loaded === false}
    <span>Loading...</span>
{/if}